import { render, staticRenderFns } from "./ExternalView.vue?vue&type=template&id=9a0c8f7c"
import script from "./ExternalView.vue?vue&type=script&lang=ts"
export * from "./ExternalView.vue?vue&type=script&lang=ts"
import style0 from "./ExternalView.vue?vue&type=style&index=0&id=9a0c8f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports